/* assets/appstle-currency.js – production */
(() => {
  /* ① add the compare-at selector */
  const SELECTOR = '.appstle_subscription_amount,'
                 + '.appstle_subscription_compare_amount';            // ← new
 
  
  const SYMBOL_SUFFIX = { BGN:'лв', CZK:'Kč', PLN:'zł' };
const ISO_SUFFIX   = new Set(['CAD','DKK','SEK','HUF','NOK','AUD']);

  /* pre-compiled regexes (cached once) */
const RX_PREFIX   = /^[^\d]+/;                               // "$", "A$", "лв "
const RX_DROP_THOUSANDS = /[\u00A0\s]|,(?=\d{3}\b)/g;         // spaces/NBSP + comma 1 000s
const RX_DROP_DOT_THOUS = /\.(?=\d{3}\b)/g;                   // dot 1 000s

  const activeISO = () =>
    (window.Shopify?.currency?.active) ||
    (window.ShopifyAnalytics?.meta?.currency) ||
    'USD';

  function patch() {
    const iso = activeISO();
    document.querySelectorAll(SELECTOR).forEach(el => {
      
      const m = el.textContent.trim().match(/^(\D*\$?\s*)?([\d.,]+)/);
      if (!m) return;

      const prefix = m[1] || '';
      /* --- VALUE PARSE (fixes 18,887.78 and 18 887,78) ------------------ */
let numStr = m[2]
  .replace(RX_DROP_THOUSANDS, '')          // drop spaces or NBSP thousands, drop comma-thousands  18,887.78 → 18887.78
  .replace(RX_DROP_DOT_THOUS, '');       // drop dot-thousands   18.887,78 → 18887,78


    
/* if the remaining string still has a comma, it’s the decimal mark → change to dot */
if (numStr.includes(',') && !numStr.includes('.')) {
  numStr = numStr.replace(',', '.');    // 18887,78 → 18887.78
}

const value = parseFloat(numStr);       // now safe: 18887.78
if (isNaN(value)) return;
/* ----------------------------------------------------------------- */

/* ---------- ROUNDING LOGIC DISABLED ---------- */
      /* The logic below is commented out to stop rounding up */
      /* ---------- ROUND-UP-ONLY RULE  (all NEW) ---------- */
      /*
      const int   = Math.floor(value);           
      const frac  = value - int;                 
      let   out;                                 

      if (frac >= 0.5) {                           // (rounds UP)
        out = `${prefix}${int + 1}`;             
      } else {                                     // (keep two dp)
        out = `${prefix}${value.toFixed(2).replace(/\.00$/, '')}`;         
      }
      */
     
      // Keep exactly two decimal places, but remove trailing .00 or ,00
      let out = `${prefix}${value.toFixed(2).replace(/\.00$/, '').replace(/,00$/, '')}`;
      /* ----------------------------------------------- */


      /* ② only the main price span gets the ISO suffix */

      
      if (el.classList.contains('appstle_subscription_amount')) {
  if (SYMBOL_SUFFIX[iso]) {
    out += '\u00A0' + SYMBOL_SUFFIX[iso];
  } else if (ISO_SUFFIX.has(iso)) {
    out += '\u00A0' + iso;
  }
}
      /* write only if the text is changing → prevents loop */
      if (out !== el.textContent) {                                       
        el.textContent = out;                                             
      }                                                                  

     
    });
  }

  document.addEventListener('appstle:widget_loaded', patch);
  const obs = new MutationObserver(() => {
    cancelAnimationFrame(obs.rafId);
    obs.rafId = requestAnimationFrame(patch);
    });
  obs.observe(document.body, { childList: true, subtree: true , passive:true});
})();
